import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import AboutUs from './pages/About Us/AboutUs';
import ContactUs from './pages/ContactUs/ContactUs';
import Locations from './pages/Locations/Locations';
import Employers from './pages/Employers/Employers';
import FindJobs from './pages/FindJobs/FindJobs';
import BackOnTop from './components/BackOnTop';
import ScrollToTop from './components/ScrollToTop';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import JobDetails from './pages/JobDetails/JobDetails';
import 'bootstrap/dist/css/bootstrap.min.css';

// Komponenta za zaštitu rute (da niko ne uđe bez login-a)
const ProtectedRoute = ({ isAllowed, children }) => {
  if (!isAllowed) {
    return <Navigate to="/admin-portal-access" replace />;
  }
  return children;
};

const AppContent = ({ isAuthenticated, setIsAuthenticated }) => {
  const location = useLocation();

  // Provera putanje za sakrivanje Header-a i Footer-a
  const isAdminPage = location.pathname.startsWith('/admin-portal-access') ||
    location.pathname.startsWith('/admin-dashboard');

  return (
    <div className="App">
      {!isAdminPage && <Header />}
      {!isAdminPage && <BackOnTop />}

      <ScrollToTop />

      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/find-jobs" element={<FindJobs />} />
        <Route path="/employers" element={<Employers />} />
        <Route path="/job/:id" element={<JobDetails />} />

        {/* Admin routes */}
        <Route
          path="/admin-portal-access"
          element={<AdminLogin onLogin={setIsAuthenticated} />}
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute isAllowed={isAuthenticated}>
              <AdminDashboard setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!isAdminPage && <Footer />}
    </div>
  );
};

function App() {
  // Stanje za autentifikaciju
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <GoogleOAuthProvider clientId="52661362467-098ql2t077co2kurr797b442romnes9a.apps.googleusercontent.com">
      <Router>
        <AppContent
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
        />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
